/* global screenReaderText */
/**
 * Theme functions file.
 *
 * Contains handlers for navigation and widget area.
 */

( function( $ ) {
    $(document).ready(function() {
        var $sidenav = $('.sidenav');

        // Toggle sidenav
        $(document).on('click', function(e) {
            var $target = $(e.target);
            var open = $sidenav.hasClass('open');

            if (open) {
                // Si clique sur la croix ou en dehors du sidenav, on ferme
                if ($target.closest('.icon-cross').length || !$target.closest('.sidenav-body').length) {
                    $sidenav.removeClass('open');
                }
            } else {
                // Si clique sur le bouton burger, on ouvre
                if ($target.closest('.burger').length) {
                    $sidenav.addClass('open');
                }
            }
        });

        $('main')
            // Toggle dropdown
            .on('click', '.dropdown-title', function() {
                $(this).closest('.dropdown').toggleClass('open');
            })

            // Toggle additional content
            .on('click', '.label-additional.content-slide', function() {
                var $this = $(this);
                $this.siblings('.additional-content').addBack().toggleClass('open');

                var html = $this.html();
                if ($this.hasClass('open')) {
                    html = html.replace(/plus/i, 'Moins');
                } else {
                    html = html.replace(/moins/i, 'Plus');
                }
                $this.html(html);
            })
        ;

        // Spécial par page
        if ($('#particulier-steps').length) {
            var $particulierSteps = $('#particulier-steps');
            var contentOffsetTop = helper.detect_mobile() ? 0 : $particulierSteps.find('.right-col').offset().top;

            $particulierSteps
                .on('click', '[data-step]', function() {
                    var newStep = $(this).data('step');

                    if (!isNaN(Number(newStep))) {
                        var newClass = 'step-' + newStep;
                        if (document.body.className.match(/step-\d/)) { // only class
                            document.body.className = document.body.className.replace(/step-\d/, newClass);
                        } else { // step doesn't appear (= first time)
                            document.body.classList.add(newClass);
                        }
                    } else if (typeof newStep === 'string') {
                        window.location.assign(newStep);
                    }
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                })
                .on('click', 'a[href^="#"]:not(a[data-toggle="collapse"])', function() {
                    var $target = $($(this).attr('href'));
                    if ($target.length) {
                        $('html, body').animate({
                            scrollTop: $target.offset().top - contentOffsetTop
                        }, 'slow');
                    }
                });

                // Ajout changement d'étape aux liens si nécéssaire
                var $contents = $particulierSteps.find('.right-col .content')

                /*$contents.find('a').each(function() {
                    var $this = $(this);
                    var href = $this.attr('href');

                    if (/^#\S+$/.test(href)) {
                        var $target = $(href);
                        if ($target.length > 0) {
                            var targetSectionId = $target.closest('section').prop('id');
                            var anchorSectionId = $this.closest('section').prop('id')

                            if (targetSectionId !== anchorSectionId) {
                                $this.attr('data-step', /step-(\d)/.exec(targetSectionId)[1]);
                            }
                        }
                    }
                });


                $contents.find('h4')
                    .nextUntil('h4')
                    .slideUp();

                $contents.find('h5')
                    .nextUntil('h5,h4')
                    .slideUp();

                $contents.find('h4').each(function(index){
                    if( $(this).attr('id') == null ) {
                        $(this).attr('id', 'auto-index-'+index);
                    }
                });

                $contents.on('click', 'h4, h5', function() {
                    var tag = $(this).prop('tagName');
                    // var filter = tag === 'H4' ? ':not(h5 ~ *:not(h5))' : '*';
                    var filter = tag === 'H4' ? '#' + $(this).attr('id') + ' ~ *:not(#' + $(this).attr('id') + ' ~ h5 ~ *:not(h5))' : '*';

                    $(this)
                        .nextUntil(tag === 'H4' ? 'H4' : 'H4, H5')
                        .filter(filter)
                        .slideToggle();
                });*/
        } else if ($('#particulier-videos').length) {
            $('.video-container').find('img[data-src]').each(function() {
                var $this = $(this);
                var src = $this.data('src');
                var matches;

                if (matches = /youtube.com\/embed\/([^\?]+)/i.exec(src)) {
                    $this.attr('src', 'https://i3.ytimg.com/vi/' + matches[1] + '/mqdefault.jpg');
                }
                else if (matches = /vimeo.com\/video\/(\d+)/i.exec(src)) {
                    $.get('https://vimeo.com/api/v2/video/' + matches[1] + '.json')
                        .then(function(response) {
                            $this.attr('src', response[0].thumbnail_large);
                        });
                }
                else if (matches = /dailymotion.com\/embed\/video\/([^\?]+)/i.exec(src)) {
                    $.get('https://api.dailymotion.com/video/' + matches[1] + '?fields=thumbnail_large_url')
                        .then(function(response) {
                            $this.attr('src', response.thumbnail_large_url);
                        });
                }
            });

            // Affichage modal
            var $videoModal = $('#video-modal');
            var $videoModalFrame = $('#video-modal-frame');

            $('.video-container').on('click', 'img[data-src]', function(e) {
                // var src = $(this).data('src');
                var src = $(this).data('media');
                var symbol = src.indexOf('?') >= 0 ? '&' : '?';

                src += symbol + 'autoplay=1';

                $videoModalFrame.attr('src', src);
                $videoModal.modal('show');
            });

            $videoModal.on('hidden.bs.modal', function() {
                $videoModalFrame.attr('src', '');
            });
        } else if ($('#contact').length) {
            // Affiche la map
            var map = new ol.Map({
                target: 'map',
                layers: [
                    new ol.layer.Tile({
                        source: new ol.source.OSM()
                    }),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat([1.7191, 46.7111]),
                    zoom: 5,
                    minZoom: 5,
                    maxZoom: 18
                })
            });

            // Affichage des marqueurs des CLLAJ
            var iconStyle = new ol.style.Style({
                image: new ol.style.Icon({
                    scale: 0.3,
                    src: 'data:image/svg+xml;utf8,<svg width="120" height="120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" ><path fill="%23333333" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"></path></svg>',
                })
            });

            var features = [];

            $('#map').siblings('.marker-container').children('.marker').each(function() {
                var $this = $(this);
                var lon = $this.data('lon');
                var lat = $this.data('lat');

                var coord = ol.proj.fromLonLat([lon, lat]);
                var point = new ol.geom.Point(coord);

                var feature = new ol.Feature({
                    geometry: point,
                });
                feature.set('cllaj-id', $this.data('id'));

                features.push(feature);
            });

            var vectorSource = new ol.source.Vector({
                features: features
            });

            var cllajLayer = new ol.layer.Vector({
                source: vectorSource,
                style: iconStyle,
            });

            map.addLayer(cllajLayer);

            var $cllajList = $('#cllaj-list');
            var $cllajListContainer = $cllajList.closest('.scrollable');
            var $isPro = $("#contact").hasClass('contact-pro');
            var $highlightedCllaj = null;
            var $offsetTop = $('header').outerHeight(true) + $('h1.main-title > div').outerHeight(true);

            // Réaction au clique sur un marqueur
            map.on('singleclick', function(e) {
                var cllajId = null;

                map.forEachFeatureAtPixel(e.pixel, function(feature) {
                    if (cllajId === null) {
                        cllajId = feature.get('cllaj-id');

                        if ($highlightedCllaj !== null) {
                            $highlightedCllaj.find('h3')
                                .removeClass('text-secondary');
                            $highlightedCllaj.find('.dropdown')
                                .removeClass('open');
                        }

                        if (cllajId !== null) {
                            $highlightedCllaj = $('#cllaj-' + cllajId);
                            $highlightedCllaj.find('h3')
                                .addClass('text-secondary');
                            $highlightedCllaj.find('.dropdown')
                                .addClass('open');

                            if ($isPro) {
                                $cllajListContainer.animate({
                                    scrollTop: $highlightedCllaj.position().top,
                                }, 'fast');
                            }
                            else {
                                $('body, html').animate({
                                    scrollTop: $highlightedCllaj.offset().top - $offsetTop,
                                }, 'fast');
                            }
                        }
                    }
                },
                {
                    layerFilter: function(candidateLayer) {
                        return candidateLayer === cllajLayer;
                    }
                });
            });
        }
    });

} )( jQuery );
